'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _Grade = require('./Grade');

var _Grade2 = _interopRequireDefault(_Grade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@spp/ui-grade')(_Grade2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-grade/lib/cjs/index.js
 ** module id = 518
 ** module chunks = 1
 **/